module.exports = __webpack_public_path__ + "img/a36bdd965fcfd8221af69a23a76fcb36.svg";